import { render, staticRenderFns } from "./Add_destination.vue?vue&type=template&id=22f66ae2&"
import script from "./Add_destination.vue?vue&type=script&lang=js&"
export * from "./Add_destination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports